import { render, staticRenderFns } from "./ItemFuncitons.vue?vue&type=template&id=01478864&"
import script from "./ItemFuncitons.vue?vue&type=script&lang=js&"
export * from "./ItemFuncitons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports